import { ChangeDetectorRef, Component, inject, Inject } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { getHelpPageUrl } from './app.module';
import { EventsService } from './services/events/events.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent {
  eventsService = inject(EventsService);
  helpButtonDisabled: boolean = false;
  productImage: string = '';

  constructor(
    @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ){}
  
  ngOnInit() {
    this.i18NextService.events.initialized.subscribe((e) => {
      if (e) {
        this.setHtmlTag(this.i18NextService.language);
      }
    });
    this.eventsService.getDisableHelpButtonEvent().subscribe((disable: boolean) => {
      this.helpButtonDisabled = disable;
      this.cdr.detectChanges();
    });
    this.eventsService.getUpdateProductImageURL().subscribe((url: string) => {
      this.productImage = url;
      this.cdr.detectChanges();
    });
  }

  //Updates the <html> lang attribute when the app is initialized or whenever the app language is changed. Required by screen readers for a11y.
  setHtmlTag(lang: string) {
    if (lang) document.documentElement.lang = lang;
  }

  getHelpPageUrl(): string {
    return getHelpPageUrl()
  }

  getProductImage(): string {
    return this.productImage;
  }
}
